import { gql } from '@apollo/client';

export const fetchInvoicesForAccountBalance = gql`
  query fetchInvoicesForAccountBalance($where: InvoiceWhereFilter, $size: Int) {
    accountInvoices(invoiceWhereFilter: $where, size: $size) {
      totalHits
      results {
        id
        invoiceNumber
        shipTo {
          id
          organization
          address {
            address1
            address2
            city
            country
            postalCode
            state
          }
          fullName
        }
        billingGroupId
      }
    }
  }
`;
